import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenProviderService } from '../services/token-provider/token-provider.service';

// Adds an Authorization header with JWT token to outgoing requests.
export function tokenInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const token = inject(TokenProviderService).accessToken();

  const newReq = req.clone({
    headers: req.headers.append('X-Access-Token', token?.accessToken || ''),
  });
  return next(newReq);
}
